import React from 'react'
import { RecipesTable } from '../../components/actions2/RecipesTable'

export const PublicRecipes = ({}) => {
    return <RecipesTable asPublicRecipes />
}
